export const base = 'gateway/main';
export const baseODATA = 'gateway/mainodata';

export const getAllCustomer = `${base}/customer`;
export const getQueryODATA = `${baseODATA}/customersearchquery`;
export const getCustomerById = `${base}/customer`;
export const postCustomer = `${base}/customer`;
